import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { useAuthStore } from './stores/auth'
import { debugLog } from './debug'
import './style.css'

let mounted = false

function showError(msg: string) {
  const el = document.getElementById('app')
  if (el) el.innerHTML = `<div style="padding:16px;color:red;font-family:monospace;font-size:11px;word-break:break-all;white-space:pre-wrap;">${msg}</div>`
}

function formatError(label: string, err: unknown): string {
  if (err instanceof Error) {
    const stack = err.stack ? '\n' + err.stack : ''
    return `${label}: ${err.name}: ${err.message}${stack}`
  }
  return `${label}: ${String(err)}`
}

debugLog.add('info', 'App starting')
debugLog.add('info', `API: ${import.meta.env.VITE_API_BASE_URL || '(same-origin proxy)'}`)
debugLog.add('info', `Office available: ${typeof Office !== 'undefined'}`)
debugLog.add('info', `UserAgent: ${navigator.userAgent}`)

function mountApp() {
  if (mounted) return
  mounted = true

  debugLog.add('info', 'mountApp called')

  try {
    const app = createApp(App)
    const pinia = createPinia()

    app.config.errorHandler = (err, instance, info) => {
      const msg = formatError(`Vue error (${info})`, err)
      debugLog.add('error', msg)
      console.error('[Korus Vue error]', err, 'info:', info, 'component:', instance)
      showError(msg)
    }

    app.use(pinia)

    const authStore = useAuthStore()
    authStore.loadSession()
    debugLog.add('info', `Session loaded, authenticated: ${authStore.isAuthenticated}`)

    app.mount('#app')
    debugLog.add('info', 'App mounted successfully')
  } catch (e) {
    const msg = formatError('Mount error', e)
    debugLog.add('error', msg)
    console.error('[Korus mount error]', e)
    showError(msg)
  }
}

window.onerror = (msg, source, lineno, colno, error) => {
  const detail = error ? formatError('Global', error) : `Global: ${String(msg)} at ${source}:${lineno}:${colno}`
  debugLog.add('error', detail)
  console.error('[Korus global error]', { msg, source, lineno, colno, error })
  showError(detail)
}
window.onunhandledrejection = (e) => {
  const detail = formatError('Promise', e.reason)
  debugLog.add('error', detail)
  console.error('[Korus unhandled rejection]', e.reason)
  showError(detail)
}

if (typeof Office !== 'undefined' && Office.onReady) {
  Office.onReady(() => {
    debugLog.add('info', 'Office.onReady fired')
    mountApp()
  })
}

setTimeout(() => {
  debugLog.add('info', 'setTimeout fallback fired')
  mountApp()
}, 3000)
